import { getAmplitudeInstance } from '@alltrails/shared/utils/amplitudeHelpers';
import WebProPurchaseLocationType from '../../amplitude/WebProPurchaseLocation';

// these events should match https://github.com/alltrails/alltrails_analytics_definition/blob/main/analytics.json
export const ACTIVITIES_NAV_BUTTON_TAPPED = 'activities nav button tapped';
export const CREATE_MAP_NAV_BUTTON_TAPPED = 'create map nav button tapped';
export const DEFAULT_CONTENT_PRIVACY_CHANGED = 'default content privacy changed';
export const EXPLORE_COMMUNITY_CONTENT_CLICKED = 'explore community content clicked';
export const EXPLORE_COMMUNITY_CONTENT_ITEM_CLICKED = 'explore community content item clicked';
export const EXPLORE_FILTER_SHEET_VIEWED = 'explore filter sheet viewed';
export const EXPLORE_FILTERS_APPLIED = 'explore filters applied';
export const EXPLORE_MAP_PAN_END = 'explore map pan end';
export const EXPLORE_NAV_BUTTON_CLICKED = 'explore nav button clicked';
export const EXPLORE_SEARCH_BOX_CLICKED = 'explore search box clicked';
export const FAVORITES_NAV_BUTTON_TAPPED = 'favorites nav button tapped';
export const FOLLOWER_REQUESTS_SETTING_CHANGED = 'follower requests setting changed';
export const GEAR_GLOBAL_HEADER_CLICKED = 'gear global header clicked';
export const GIVE_PRO_GLOBAL_HEADER_CLICKED = 'give pro global header clicked';
export const GLOBAL_NAV_SIGNUP_BUTTON_TAPPED = 'global nav signup button tapped';
export const HISTORIES_NAV_BUTTON_TAPPED = 'histories nav button tapped';
export const HOMEPAGE_SIGNUP_BUTTON_TAPPED = 'homepage signup button tapped';
export const INDIVIDUAL_CONTENT_PRIVACY_CHANGED = 'individual content privacy changed';
export const INVITED_USER_CREATE_ACCOUNT_CLICKED = 'invited user create account clicked';
export const INVITED_USER_DOWNLOAD_APP_CLICKED = 'invited user download app cta clicked';
export const INVITED_USER_DOWNLOAD_PAGE_VIEWED = 'invited user download page viewed';
export const INVITED_USER_LANDING_PAGE_VIEWED = 'invited user landing page viewed';
export const LISTS_NAV_BUTTON_TAPPED = 'lists nav button tapped';
export const LOG_IN_PAGE_SIGNUP_BUTTON_TAPPED = 'log in page signup button tapped';
export const MAP_BASE_LAYER_TAPPED = 'map base layer tapped';
export const MAPS_NAV_BUTTON_TAPPED = 'maps nav button tapped';
export const ONE_TAP_DISPLAYED = 'one tap displayed';
export const PRINT_FAILED = 'print failed';
export const PRINT_STARTED = 'print started';
export const PRINT_SUCCEEDED = 'print succeeded';
export const PRINT_MAP_CLICKED = 'print map clicked';
export const PRIVACY_SETTINGS_PAGE_VIEWED = 'privacy settings page viewed';
export const PRO_GLOBAL_HEADER_UPGRADE_CLICKED = 'pro global header upgrade clicked';
export const PRO_PURCHASE_GET_STARTED_CLICKED = 'pro purchase get started clicked';
export const PRO_PURCHASE_PAGE_VIEWED = 'pro purchase page viewed';
export const REVIEW_FORM_VIEWED = 'review form viewed';
export const REVIEW_UPDATED = 'review updated';
export const SEARCH_RESULT_SELECTED = 'search result selected';
export const SIGN_UP_PAGE_VIEWED = 'sign up page viewed';
export const SIGN_UP_SUCCEEDED = 'sign up succeeded';
export const STATIC_MAP_TAPPED = 'static map tapped';
export const STATS_NAV_BUTTON_TAPPED = 'stats nav button tapped';
export const TRAIL_CARD_ADD_TO_LIST_BUTTON_TAPPED = 'trail card add to list button tapped';
export const TRAIL_DETAILS_ADD_TO_LIST_BUTTON_TAPPED = 'trail details add to list button tapped';
export const TRAIL_DETAILS_GPX_DOWNLOAD_BUTTON_TAPPED = 'trail details gpx download button tapped';
export const TRAIL_DETAILS_PRINT_BUTTON_TAPPED = 'trail details print button tapped';
export const TRAIL_DETAILS_SHARE_BUTTON_TAPPED = 'trail details share button tapped';
export const TRAIL_PAGE_VIEW_LIMIT_REACHED = 'trail page view limit reached';
export const USER_RELATIONSHIPS_PRIVACY_CHANGED = 'user relationships privacy changed';

enum AmplitudeEvent {
  ProWelcomePageViewed = 'pro welcome page viewed',
  ProPurchaseBuyNowClicked = 'pro purchase buy now clicked',
  PurchaseSuccess = 'purchase success',
  ExploreWithProButtonClicked = 'explore with pro button clicked'
}

// prep for Ben/Travis PR
export const logPurchaseSuccess = () => {
  getAmplitudeInstance().logEvent(AmplitudeEvent.PurchaseSuccess);
};

export const logProWelcomePageViewed = () => {
  getAmplitudeInstance().logEvent(AmplitudeEvent.ProWelcomePageViewed);
};

export const logExploreWithProButtonClicked = () => {
  getAmplitudeInstance().logEvent(AmplitudeEvent.ExploreWithProButtonClicked);
};

export const logProPurchaseBuyNowClicked = (WebProPurchaseLocation: WebProPurchaseLocationType) => {
  getAmplitudeInstance().logEvent(AmplitudeEvent.ProPurchaseBuyNowClicked, { 'web purchase location': WebProPurchaseLocation });
};
